import { useEffect, useState } from "react";
import { DEFAULT_SETTINGS } from "./constants";
import { readJson, writeJson } from "./storage";
import type { Settings } from "./types";
import { normalizeSettings } from "./hijriRegional";

export function useSettingsState() {
  const [settings, setSettings] = useState<Settings>(() =>
    normalizeSettings(readJson<Settings>("settings", DEFAULT_SETTINGS as unknown as Settings))
  );

  useEffect(() => {
    writeJson("settings", settings);
  }, [settings]);

  return { settings, setSettings };
}
